import { Controller } from '@hotwired/stimulus'
// @ts-expect-error: el-transition is not typed
import { enter, leave } from 'el-transition'

// Connects to data-controller="edit-allowance-dialog"
export default class extends Controller {
  static targets = [
    'dialog',
  ]

  declare readonly dialogTarget: HTMLDialogElement

  connect () {
    this.dialogTarget.showModal()
    enter(this.dialogTarget)
    document.body.classList.add('modal-open') // Locks scrolling
  }

  close (event: Event): void {
    event.preventDefault()

    leave(this.dialogTarget).then(() => {
      this.dialogTarget.close()
      document.body.classList.remove('modal-open') // Unlocks scrolling
    })
  }
}
